import React from "react";

const PaymentBanner = () => {
  return (
    <div className="cont my-5">
      <div className="payment-banner">
        <div className="payment-banner-img-1">
          <img src="./images/payment/payment-1.png" alt=" " />
        </div>
        <div className="payment-banner-img">
          <img src="./images/payment/mpesa.png" alt=" " />
        </div>
      </div>
    </div>
  );
};

export default PaymentBanner;
